import { createReducer } from '../../store.model';

import { categorizeGoals } from './categorize-goals.function';
import { GoalCategoryType } from './goal-category-type.model';
import {
    ActionType,
    Reload,
    SetCategoryOpenState,
    Sort,
} from './goal-list.action';
import { defaultState, GoalListState } from './goal-list.state';

const { builder, reducer } = createReducer<ActionType, GoalListState>(
    defaultState(),
);

builder.add<Reload>(
    ActionType.COACHING_COMMITMENT__GOAL_LIST__RELOAD,
    (state, action) => {
        const categoryOpenState = state.categories
            ? state.categories.map((e) => e.isOpen)
            : new Array<boolean>(5);
        const commitmentKpis = action.payload.commitmentKpis;
        const focusKpis =
            action.payload.focusKpis && action.payload.goalsFromOtherCommitments
                ? action.payload.focusKpis.filter((e) =>
                      action.payload.goalsFromOtherCommitments.every(
                          (g) => g.metricId !== e.metricId,
                      ),
                  )
                : action.payload.focusKpis;

        const nextCategories = categorizeGoals(
            commitmentKpis,
            action.payload.goalsFromOtherCommitments,
            focusKpis,
            action.payload.goalThresholds,
            action.payload.approval,
            action.payload.authUserId,
        );

        // when categories become opened, override the state
        nextCategories.forEach((e, ei) => {
            if (e.isOpen) {
                categoryOpenState[ei] = e.isOpen;
            }
        });

        !action.payload.reset &&
            nextCategories.forEach((e, ei) => {
                e.isOpen =
                    categoryOpenState[ei] != null
                        ? categoryOpenState[ei]
                        : e.isOpen;
            });

        const active = [
            ...nextCategories[GoalCategoryType.ACTIVE_FOR_THIS_COMMITMENT]
                .items,
            ...nextCategories[GoalCategoryType.ACTIVE_FOR_OTHER_COMMITMENT]
                .items,
        ];
        const nextIsOriginalWithDraftTrackingIdMap: {
            [trackingId: number]: boolean;
        } = {};
        active.forEach((e) => {
            nextIsOriginalWithDraftTrackingIdMap[e.goal.tracking_id] =
                e.isOriginalWithDraft;
        });

        return {
            ...state,
            categories: nextCategories,
            isOriginalWithDraftTrackingIdMap:
                nextIsOriginalWithDraftTrackingIdMap,
        };
    },
);

builder.add<Sort>(ActionType.COACHING_COMMITMENT__GOAL_LIST__SORT, (state) => {
    return {
        ...state,
        sortOrder: state.sortOrder === 'asc' ? 'desc' : 'asc',
    };
});

builder.add<SetCategoryOpenState>(
    ActionType.COACHING_COMMITMENT__GOAL_LIST__SET_CATEGORY_OPEN_STATE,
    (state, action) => {
        if (
            state.categories[action.payload.index].isOpen ===
            action.payload.isOpen
        ) {
            return state;
        }

        const nextCategories = [...state.categories];
        nextCategories[action.payload.index] = {
            ...nextCategories[action.payload.index],
            isOpen: action.payload.isOpen,
        };

        return {
            ...state,
            categories: nextCategories,
        };
    },
);

export const coachingCommitmentGoalListReducer = reducer;
